import { z } from 'zod'

export const corePriceSchema = z.object({
  paymentTypeId: z.number(),
  nameOnBill: z.string(),
  nameOnBillSv: z.string().nullable(),
  nameOnBillEn: z.string().nullable(),
  price: z.number(),
  validFrom: z.string(),
  validTo: z.string().nullable(),
})

export const coreReservationSchema = z.object({
  kind: z.string(),
  startDate: z.string(),
  endDate: z.string().nullable(),
})

export const coreAvailableRangeSchema = z.object({
  startDate: z.string(),
  endDate: z.string().nullable(),
})

export const coreParkingSpotSchema = z.object({
  rentableParkingSpotId: z.number(),
  isInUse: z.boolean(),
  additionalDetails: z.string().nullable(),
  locationDetails: z.string().nullable(),
  equipment: z.array(z.string()),
  heatingKeyType: z.string().nullable(),
  electricityBillingType: z.string().nullable(),
  prices: z.array(corePriceSchema),
  reservations: z.array(coreReservationSchema),
  availableRanges: z.array(coreAvailableRangeSchema),
})

export const coreParkingAreaLocationSchema = z.object({
  parkingAreaType: z.string(),
  locationDetails: z.string(),
  address: z.object({
    streetName: z.string(),
    streetNumber: z.string(),
    city: z.string(),
  }),
})

export const coreParkingAreaSchema = z.object({
  realPropertyHierarchyId: z.number(),
  location: coreParkingAreaLocationSchema,
  parkingSpots: z.array(coreParkingSpotSchema),
  costPoolId: z.number(),
})

export const contractParkingSpotsDataSchema = z.object({
  parkingAreas: z.array(coreParkingAreaSchema),
  limitations: z
    .object({
      perContractSlotLimit: z.number(),
      complimentarySlotsPerContract: z.number(),
      canTenantReserveSlotsForDisabled: z.boolean(),
    })
    .nullable(),
  reservationPossibleUntil: z.string().nullable(),
})

export type contractParkingSpotsData = z.infer<
  typeof contractParkingSpotsDataSchema
>
export type CoreParkingArea = z.infer<typeof coreParkingAreaSchema>
export type CoreParkingSpot = z.infer<typeof coreParkingSpotSchema>
export type CoreParkingSpotPrice = z.infer<typeof corePriceSchema>
export type CoreParkingSpotReservation = z.infer<typeof coreReservationSchema>
